// extracted by mini-css-extract-plugin
export default {"background":"Home_background__J5LLU","container":"Home_container__wOY5E","bgHeader":"Home_bgHeader__HtV4Q","slider":"Home_slider__1-CCV","slick-active":"Home_slick-active__jQ3NG"};